import { render, staticRenderFns } from "./outpatient.vue?vue&type=template&id=21fe8f72&scoped=true"
import script from "./outpatient.vue?vue&type=script&lang=js"
export * from "./outpatient.vue?vue&type=script&lang=js"
import style0 from "./outpatient.vue?vue&type=style&index=0&id=21fe8f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fe8f72",
  null
  
)

export default component.exports